import { createQuestionPanelId, ensureIdDoesNotStartWithPrefix } from '@avantia/questionset-model';

import { HpStringAnswerSource } from '../../types';
import { ErrorWidget } from './errorWidget';
import { HpFormGroupClassTypes } from './standardFormGroupWidget';

export interface HpFluentFormGroupProps {
  answerSource: HpStringAnswerSource;
  controlType: HpFormGroupClassTypes;
  error: string | undefined;
  id: string;
  question: string | JSX.Element;
}

export function FluentFormGroupWidget({
  answerSource,
  controlType,
  error,
  id,
  question
}: HpFluentFormGroupProps): JSX.Element {
  ensureIdDoesNotStartWithPrefix(id);

  return (
    <div
      id={createQuestionPanelId(id)}
      className={`hp-fluent hp-${controlType} hp-answer-${answerSource} ${error ? 'av-input-error' : ''}`}
    >
      <ErrorWidget error={error} />
      <div className="av-field-section">{question}</div>
    </div>
  );
}
